//////////////////////////////////////////////////

const cmps = require('./list_components');

module.exports = {

    item: {
        title_list      : 'Documenti Notarizzati',
        order           : 'created DESC', // * TODO TODO TODO TODO TODO TODO TODO
        add             : true,
        edit            : true,
        include         : true,
        edit_action     : 'button',
        details_tooltip : 'Gestisci la Proposta',
        search_schema   : 'search_item',
        paginate        : true,
        fields: [
            // sempre visibili { screen: 'mobile' },
            { key: 'config.status', sortable: true, label: 'Stato', component: cmps['item/status'], screen: 'mobile' },
            { key: 'title', sortable: true, label: 'Titolo', screen: 'mobile' },
            { key: 'owner', sortable: true, label: 'Utente', component: cmps['item/owner'], screen: 'mobile' },
            { key: 'created', label: 'Creata', htmlformatter: 'format_datetime_t2', sortable: true, screen: 'mobile' },
            { key: 'download', sortable: false, label: '', component: cmps['item/download'], screen: 'mobile' },
            { key: 'qrcode', sortable: false, label: ' ', component: cmps['item/qrcode'], screen: 'mobile' },
            { key: 'email_button', sortable: false, label: '  ', component: cmps['item/email'], screen: 'mobile' },
            { key: 'email', sortable: false, label: 'Email', display: false },
            { key: 'code', sortable: false, label: 'Codice', display: false },
            { key: 'codice_fiscale', sortable: false, label: 'Codice Fiscale', display: false },
            { key: 'actions', sortable: false, label: 'Azioni', component: cmps['item/ab'], display: false },
        ],
    },

};

